import type {JourneyProgressStage} from "~/components/journeyProgressCard/types";
import type {CustomerProfileLifecycleItem} from "~/components/entityProfile/lifecycle/types";
import {uniqueUuid} from "@vesta/unique/unique";

const LIFECYCLE_STAGE_LABELS = ["Leads", "Calls", "Walk-ins", "Testride", "Sales"] as const;

function buildStages(completedCount: number): JourneyProgressStage[] {
    return LIFECYCLE_STAGE_LABELS.map((label, index) => ({
        id: `${label.toLowerCase()}-${index}`,
        label,
        state: index < completedCount ? "completed" : "notStarted",
    }));
}

const MOCK_LIFECYCLE_3_ID = uniqueUuid`f1a2b3c4-d5e6-4789-a012-3456789abc01`;
const MOCK_LIFECYCLE_2_ID = uniqueUuid`f2a3b4c5-d6e7-4890-b123-456789abcd02`;
const MOCK_LIFECYCLE_1_ID = uniqueUuid`f3a4b5c6-d7e8-4901-c234-567890abcde3`;

export {
    MOCK_LIFECYCLE_1_ID,
    MOCK_LIFECYCLE_2_ID,
    MOCK_LIFECYCLE_3_ID,
};

/** Base lifecycle cards until the customer journeys API is wired. */
export const MOCK_CUSTOMER_PROFILE_LIFECYCLE_BASES: Array<
    Omit<CustomerProfileLifecycleItem, "actions" | "onDisposeClick">
> = [
    {
        id: MOCK_LIFECYCLE_3_ID,
        title: "Lifecycle 3",
        status: "active",
        createdAtLabel: "2 Dec 2025, 12:30pm",
        ouName: "GKNM showroom",
        stages: buildStages(3),
    },
    {
        id: MOCK_LIFECYCLE_2_ID,
        title: "Lifecycle 2",
        status: "inactive",
        createdAtLabel: "2 Dec 2025, 12:30pm",
        ouName: "GKNM showroom",
        stages: buildStages(3),
    },
    {
        id: MOCK_LIFECYCLE_1_ID,
        title: "Lifecycle 1",
        status: "inactive",
        createdAtLabel: "2 Dec 2025, 12:30pm",
        ouName: "GKNM showroom",
        stages: buildStages(2),
    },
];
